(() => {
  function boot(root = document) {
    root.querySelectorAll('[data-wn-conversion-layer]').forEach((config) => {
      if (config.dataset.ready === 'true') return;
      config.dataset.ready = 'true';
      const shell = config.closest('wn-product-form');
      const form = shell?.querySelector('form.wn-product-form');
      if (!shell || !form) return;

      let stockMap = [];
      try { stockMap = JSON.parse(config.querySelector('[data-wn-stock-map]')?.textContent || '[]'); } catch { stockMap = []; }
      const lowStockNode = form.querySelector('.wn-conversion-urgency--stock');
      const lowStockCopy = lowStockNode?.querySelector('[data-wn-low-stock-copy]');
      const lowStockEnabled = config.dataset.lowStockEnabled !== 'false';
      const lowStockThreshold = Math.max(1, Number(config.dataset.lowStockThreshold || 8));
      const lowStockPattern = config.dataset.lowStockTemplate || 'Only [count] left';
      const syncLowStock = (variantId) => {
        if (!lowStockNode || !lowStockCopy || !lowStockEnabled) return;
        const item = stockMap.find((entry) => String(entry.id) === String(variantId));
        const show = Boolean(item?.tracked && item.available && Number(item.quantity) > 0 && Number(item.quantity) <= lowStockThreshold);
        lowStockNode.hidden = !show;
        if (show) lowStockCopy.textContent = lowStockPattern.replace('[count]', String(item.quantity));
      };
      syncLowStock(form.querySelector('[data-variant-id]')?.value);
      shell.addEventListener('wn:product:variant-change', (event) => syncLowStock(event.detail?.variant?.id));

      const giftVariantId = Number(config.dataset.giftVariantId || 0);
      const parentProductId = String(config.dataset.parentProductId || '').replace(/\D/g, '');
      if (!giftVariantId || !parentProductId || !window.WNCart?.add) return;
      let addingGift = false;
      shell.addEventListener('wn:product:add-success', async (event) => {
        if (addingGift) return;
        const cart = event.detail?.cart;
        if (!cart?.items) return;
        const alreadyPresent = cart.items.some((item) => Number(item.variant_id) === giftVariantId && String(item.properties?._wn_gift_for || '') === parentProductId);
        if (alreadyPresent) return;
        addingGift = true;
        try {
          await window.WNCart.add({ items: [{ id: giftVariantId, quantity: 1, properties: { _wn_gift: '1', _wn_gift_for: parentProductId } }] }, { source: 'free-gift', openDrawer: true });
        } catch (error) {
          console.warn('Wandersnout gift could not be added', error);
        } finally {
          addingGift = false;
        }
      });
    });
  }
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
})();
